import React, { Component, Fragment } from 'react';

import './HistoricalArchive.css';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

import classNames from 'classnames';
import request from '@acri-tools/react-tools/utils/request';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import parse from 'csv-parse/lib/sync';

// import Chart from '../../../../components/Chart/Chart';
import Chart from 'react-apexcharts'
import Select from '@acri-tools/react-tools/components/Select/Select';
import { format_bytes, get_data_file_url, MISSION_COLOR_PALETTE } from '../../../../utils/data';
import { download_chart } from '../../../../utils/charts';

/**
 * Chart download : 
 * https://stackoverflow.com/questions/60110892/how-can-i-get-uri-from-apexcharts-with-react-js
 * https://codesandbox.io/s/react-datauri-stackoverflow-60110892-iryeq?file=/src/App.js
 * https://apexcharts.com/docs/methods/#dataURI
 */

type Metric = 'nb_prod' | 'size(GB)'

interface Props {
}
interface State {
    loading: boolean
    metric: Metric

    orderby: string
    direction: string
    data?: any[]
    missions?: string[]

    pie_data?: any

    big_mode: boolean
}


// const esa_missions = [ 'Cryosat-2', 'Envisat', 'ERS-1', 'ERS-2', 'GOCE', 'Proba-V', 'Proba-1', 'SMOS', 'Swarm' ]

const esa_missions = [
    'Cryosat-2', 'Envisat', 'ERS-2', 'SMOS', 'ERS-1',
    'GOCE', 'Swarm', 'Aeolus', 'PROBA-1', 'ESACampaign',
    'EarthCARE', 'Biomass', 'FLEX'
];

// const third_party_missions = [
//     'ALOS-1', 'Landsat-5', 'NOAA', 'ODIN',
//     'Landsat-8', 'Landsat', 'Landsat-7', 'JERS-1',
//     'Orbview-2 SeaStar', 'SCISAT-1', 'OceanSat-2', 'Windsat',  

// ];
// const third_party_missions = [
//     'ADEOS', 'ALOS', 'AQUA', 'Deimos-1', 'IKONOS-2', 'Jers-1', 'KOMPSAT1', 'KOMPSAT-2',
//     'Landsat-5', 'Landsat-7', 'MOS-1', 'MOS-1B', 'MOS-1,MOS-1B', 'Nimbus-7',
//     'Orbview-2 SeaStar', 'PL1', 'QuikSCAT', 'RapidEye', 'SCISAT', 'SEASAT',
//     'Spot 1', 'SPOT 1-4', 'Spot 2', 'Spot-4 Spot-5 IRS-P6', 'SPOT 6-7',
//     'Terra ', 'Windsat', 'WorldView-2'
// ];


export default class HistoricalArchive extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false,
            metric: 'nb_prod',
            orderby: 'value',
            direction: 'desc',

            big_mode: false
        }
    }

    componentDidMount() {
        this.fetch_data()
    }


    fetch_data = async () => {
        this.setState({ loading: true });
        try {
            let res = await request(get_data_file_url(`ingestion_mission_details.csv`), {
                // let res = await request(`${API_URL}/api/user-manager/v1/files/media/ingestion_dataset_detail_v2.csv`,{
                method: 'get'
            })

            let csv_data = parse(res.data, { from: 1, delimiter: ';' });

            let headers = csv_data.shift();
            let missions: any = [];
            let data: Array<any> = csv_data.map((row: Array<string>) => {
                let d: any = {}
                headers.forEach((col: string, index: number) => {
                    d[col] = row[index];
                    if (col === 'mission' && !missions.includes(row[index]))
                        missions.push(row[index])
                })
                return d;
            })

            await this.setState({ data, missions });

            this.filter_data(data, missions);
        }
        catch (e: any) {
            axiosErrorHandler(e, { functionName: `fetch_data` });
            toast_request_error(e);
        }
        finally {
            this.setState({ loading: false })
        }
    }

    sanetize_title = (title: string) => {
        return `${title.toLowerCase().replace(/[\/\s]/g, '_')}_${this.state.metric === 'nb_prod' ? 'number' : 'volume'
            }_${this.state.orderby}_${this.state.direction}`
    }

    download_url = (title: string) => {
        let data_query;
        switch (title) {
            case "All Missions": data_query = 'all_missions'; break;
            case "ESA & Third-Party Missions": data_query = 'esa_and_tpm'; break;
            case "Third-Party Missions": data_query = 'tpm'; break;
            case "ENVISAT Instruments": data_query = 'envisat'; break;
            case "ERS-1 Instruments": data_query = 'ers-1'; break;
            case "ERS-2 Instruments": data_query = 'ers-2'; break;
        }
        return `/api/v1/charts/historical_archive_composition?${[
            `sort_direction=${this.state.direction === 'asc' ? 'ascending' : 'descending'}`,
            `sort_field=${this.state.orderby}`,
            `field=${this.state.metric === 'nb_prod' ? 'nb_prod' : 'size'}`,
            `legend_position=${this.state.big_mode ? 'bottom' : 'right'}`,
            `data_query=${data_query}`,
            `background=true`
        ].join('&')}`
    }

    get_pie_chart = (title: string, data: Array<any>, legend: Array<string>) => {
        let id = `${title}`;
        return (
            <div className="pie-chart">
                <div className="pie-chart-title">
                    {title}
                    <a
                        className="custom-button inline small alt icon-only inverted tt"
                        download={this.sanetize_title(title)}
                        href={this.download_url(title)}
                    >
                        <i className="fas fa-download" />
                        <div className="tt-tooltip" > download</div>
                    </a>
                </div>
                <div className={classNames({
                    "pie-chart-chart": true,
                    "compensate": !this.state.big_mode && legend.length <= 12,
                    "big": this.state.big_mode
                })}>
                    <Chart

                        height={this.state.big_mode ? 800 : undefined}
                        // width={!this.state.big_mode ? 600 : undefined}
                        type="pie"
                        series={data.map((d) => { return d.value })}
                        options={{
                            chart: { id }, // Id set to be downlaoded later
                            colors: MISSION_COLOR_PALETTE,
                            labels: data.map((d) => { return `${d.label} (${d.percentage}%)` }),
                            legend: {
                                position: this.state.big_mode ? 'bottom' : 'right'
                            },
                            tooltip: {
                                y: {
                                    formatter: (value, { series, seriesIndex, dataPointIndex, w }) => {
                                        // The value stored in the CSV is in GB, so to have the good unit, need to multiply by 10^3 which is the factor from Bytes to GigaBytes
                                        return `${this.state.metric === 'nb_prod' ? value : format_bytes(value * Math.pow(1000, 3), { base: 1000 })}`;
                                    }
                                }
                            }
                        }}
                    />
                </div>
            </div>
        )
    }

    filter_data = (data?: any[], missions?: string[]) => {
        let pie_data = {
            "ESA & Third-Party Missions": { data: this.esa_tpm_missions({ data, missions }) },
            "All Missions": { data: this.number_of_products({ data }) },
            "Third-Party Missions": {
                data: this.number_of_products({
                    missions: (missions || this.state.missions)?.filter((m: string) => !esa_missions.includes(m)),
                    data
                })
            },
            "ENVISAT Instruments": { data: this.number_of_products_instruments({ mission: 'Envisat', data }) },
            "ERS-1 Instruments": { data: this.number_of_products_instruments({ mission: 'ERS-1', data }) },
            "ERS-2 Instruments": { data: this.number_of_products_instruments({ mission: 'ERS-2', data }) }
        };

        Object.values(pie_data).forEach((d: any) => {
            d.legend = this.get_legend(d.data)
        });

        this.setState({ pie_data });
    }

    get_legend = (data: any) => {
        let labels: any[] = [];
        for (let d of data) {
            if (!labels.includes(d.label)) labels.push(d.label)
        }
        // console.log("labels", labels)
        return labels;
    }

    render() {
        return (
            <div className="historical-archive">
                <div className="historical-archive-filters">
                    <div className="form-field">
                        <label>Metric</label>
                        <Select
                            value={this.state.metric}
                            options={[
                                { label: <>Number of products</>, value: 'nb_prod' },
                                { label: <>Volume</>, value: 'size(GB)' }
                            ]}
                            onChange={async (metric: Metric) => {
                                await this.setState({ metric });
                                this.filter_data();
                            }}
                        />
                    </div>
                    <div className="form-field">
                        <label><i className="fas fa-filter" /> Order By</label>
                        <Select
                            value={this.state.orderby}
                            options={[
                                { label: <>Value</>, value: 'value' },
                                { label: <>Name</>, value: 'name' }
                            ]}
                            onChange={async (orderby: string) => { await this.setState({ orderby }); this.filter_data(); }}
                        />
                    </div>
                    <div className="form-field">
                        <label><i className="fas fa-sort" /> Order By Direction</label>
                        <Select
                            value={this.state.direction}
                            options={[
                                { label: <><i className="fas fa-sort-amount-down" /> Descending</>, value: 'desc' },
                                { label: <><i className="fas fa-sort-amount-down-alt" /> Ascending</>, value: 'asc' }
                            ]}
                            onChange={async (direction: string) => { await this.setState({ direction }); this.filter_data(); }}
                        />
                    </div>
                    <div className="form-field">
                        <label><i className="fas fa-align-justify" /> Legend position</label>
                        <Select
                            value={this.state.big_mode}
                            options={[
                                { label: <><i className="fas fa-chevron-down" /> Bottom</>, value: true },
                                { label: <><i className="fas fa-chevron-right" /> Right</>, value: false }
                            ]}
                            onChange={async (big_mode: boolean) => { await this.setState({ big_mode }); this.filter_data(); }}
                        />
                    </div>
                </div>
                {
                    this.state.loading ?
                        <div className="centered">
                            <Spinner />
                        </div>
                        :
                        this.state.data &&
                        <div className="pie-charts">
                            {
                                this.state.pie_data &&
                                Object.keys(this.state.pie_data).map((title, idx) =>
                                    <Fragment key={idx}>
                                        {this.get_pie_chart(title, this.state.pie_data[title].data, this.state.pie_data[title].legend)}
                                    </Fragment>
                                )
                            }
                            {/* {
                            this.get_pie_chart("ESA & Third-Party Missions", this.esa_tpm_missions())
                        }
                        {
                            this.get_pie_chart("All Missions", this.number_of_products())
                        }
                        {
                            this.state.missions &&
                            this.get_pie_chart("Third-Party Missions", this.number_of_products(
                                this.state.missions.filter((m:string)=> !esa_missions.includes(m))
                            ))
                        }
                        {
                            this.get_pie_chart("ENVISAT Instruments", this.number_of_products_instruments('Envisat'))
                        }
                        {
                            this.get_pie_chart("ERS-1 Instruments", this.number_of_products_instruments('ERS-1'))
                        }
                        {
                            this.get_pie_chart("ERS-2 Instruments", this.number_of_products_instruments('ERS-2'))
                        } */}
                        </div>
                }
            </div>
        );
    }


    esa_tpm_missions = ({ data, missions }: { data?: any[], missions?: string[] }) => {

        if (!data) data = this.state.data;
        if (data) {
            let entity_values: any = {};
            let total = 0;

            let { metric } = this.state;

            for (let d of data) {
                let tpm = !esa_missions.includes(d.mission);
                let column = tpm ? 'TPM' : d.mission;
                try {
                    let value = parseInt(d[metric]);
                    total += value;
                    if (column in entity_values)
                        entity_values[column] += value;
                    else
                        entity_values[column] = value;
                }
                catch (e: any) { console.error(`Aggegation error`, d, e); }
            }

            return Object.keys(entity_values).map(((entity) => {
                let raw = entity_values[entity] / total * 100;
                let parsedPercentage = this.formatAdaptive(raw);
                return {
                    label: entity,
                    percentage: parsedPercentage,
                    value: entity_values[entity]
                }
            })).sort(this.get_sort());
        }
    }

    formatAdaptive(num: number) {
        if (num === 0) return "0";

        let result;

        if (num >= 1) {
            result = num.toFixed(2);
        } else if (num >= 0.000001) {
            result = num.toPrecision(1);
        } else {
            result = num.toPrecision(1);
        }

        // Convert to number and back to string to remove unnecessary trailing zeroes
        result = parseFloat(result).toString();

        return result;
    }

    number_of_products = ({ missions, data }: { missions?: string[], data?: any[] }) => {
        if (!data) data = this.state.data;
        if (data) {
            let entity_values: any = {};
            let total = 0;

            let { metric } = this.state;

            for (let d of data) {
                if (missions && !missions.includes(d.mission)) continue;
                try {
                    let value = parseInt(d[metric]);
                    total += value;
                    if (d.mission in entity_values)
                        entity_values[d.mission] += value;
                    else
                        entity_values[d.mission] = value;
                }
                catch (e: any) { console.error(`Aggegation error`, d, e); }
            }

            // console.log("mission", mission_nb_prod);

            return Object.keys(entity_values).map(((entity) => {
                let raw = entity_values[entity] / total * 100;
                let parsedPercentage = this.formatAdaptive(raw);
                return {
                    label: entity,
                    percentage: parsedPercentage,
                    value: entity_values[entity]
                }
            })).sort(this.get_sort());
        }

    }

    number_of_products_instruments = ({ mission, data }: { mission: string, data?: any[] }) => {
        if (!data) data = this.state.data;
        if (data) {
            let entity_values: any = {};
            let total = 0;

            let { metric } = this.state;

            for (let d of data) {
                if (!(d.mission === mission)) continue;
                try {
                    let value = parseFloat(d[metric]);
                    total += value;
                    if (d.instrument in entity_values)
                        entity_values[d.instrument] += value;
                    else
                        entity_values[d.instrument] = value;
                }
                catch (e: any) { console.error(`Aggegation error`, d, e); }
            }

            // console.log("mission", mission_nb_prod);

            return Object.keys(entity_values).map(((entity) => {
                let raw = entity_values[entity] / total * 100;
                let parsedPercentage = this.formatAdaptive(raw);
                return {
                    label: entity,
                    percentage: parsedPercentage,
                    value: entity_values[entity]
                }
            })).sort(this.get_sort());
        }

    }

    get_sort = () => {
        let { orderby, direction } = this.state;
        switch (orderby) {
            case 'name':
                return (a: any, b: any) => direction === 'desc' ?
                    b.label.localeCompare(a.label)
                    :
                    a.label.localeCompare(b.label);
            default:
                return (a: any, b: any) => direction === 'desc' ?
                    b.value - a.value
                    :
                    a.value - b.value;
        }
    }
};
